import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { exhaustMap, map, catchError } from 'rxjs/operators';
import { DocumentTypeService } from '../../inventory/document-type.service';
import { DocumentService } from '../../inventory/document.service';
import * as DocumentsActions from './documents.actions';

@Injectable()
export class DocumentsEffects {
  documentsList$ = createEffect(() =>
    this.actions.pipe(
      ofType(DocumentsActions.fetchDocuments),
      exhaustMap(() =>
        this.documentsService.getItems().pipe(
          map((response) =>
            DocumentsActions.getDocumentsSuccess({
              documents: response,
            })
          ),
          catchError((err) => of(DocumentsActions.getDocumentsError({ error: err })))
        )
      )
    )
  );

  documentTypesList$ = createEffect(() =>
    this.actions.pipe(
      ofType(DocumentsActions.fetchDocumentTypes),
      exhaustMap(() =>
        this.documentTypesService.getItems().pipe(
          map((response) => DocumentsActions.getDocumentTypesSuccess({documentTypes: response})
          ),
          catchError((err) => of(DocumentsActions.getDocumentTypesFail()))
        )
      )
    )
  );

  constructor(
    private actions: Actions,
    private documentsService: DocumentService,
    private documentTypesService: DocumentTypeService
  ) {}
}
